var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundedCaretUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15C7.13596e-07 6.71573 6.71573 -7.13596e-07 15 0C23.2843 7.13596e-07 30 6.71573 30 15C30 23.2843 23.2843 30 15 30C6.71573 30 -7.13596e-07 23.2843 0 15ZM15 2.99304C8.36874 2.99304 2.99304 8.36874 2.99304 15C2.99304 21.6313 8.36874 27.007 15 27.007C21.6313 27.007 27.007 21.6313 27.007 15C27.007 8.36874 21.6313 2.99304 15 2.99304ZM13.9789 10.621C14.5539 10.0844 15.4461 10.0844 16.0211 10.621L21.4955 15.7304C22.0997 16.2944 22.1324 17.2414 21.5684 17.8456C21.0045 18.4498 20.0575 18.4825 19.4533 17.9185L15 13.7621L10.5467 17.9185C9.94249 18.4825 8.99551 18.4498 8.43157 17.8456C7.86763 17.2414 7.90028 16.2944 8.5045 15.7304L13.9789 10.621ZM20.6781 16.6052C20.6783 16.6054 20.6784 16.6055 20.6786 16.6057L20.6781 16.6052Z",
    fill: "#1F1646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedCaretUp);
export default __webpack_public_path__ + "static/media/rounded_caret_up.bd5c36f0.svg";
export { ForwardRef as ReactComponent };